import React from "react";
import "./FourOfour.css";

const FourOfour = () => {
  return (
    <div className="pagenot-container text-center text-danger">
      <h1>Page Not Found!!</h1>
    </div>
  );
};

export default FourOfour;
